import React, { useState } from "react";
import { Box, Grid } from "@mui/material";
import ColorPickerDialog from "./ColorPickerDialog";

const ColorPickerElement = ({
  property,
  initialColor = "#3b82f6",
  label = "Color Picker",
  linkedProperties,
  updateChanges
}) => {
  const [colorDialogOpen, setColorDialogOpen] = useState(false);

  return (
    <>
      <Grid item xs={6} style={{ alignContent: "center" }}>
        {label}
      </Grid>
      <Grid item xs={6} style={{ alignContent: "center" }}>
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: 2,
            border: "2px solid #e0e0e0",
            backgroundColor: initialColor,
            flexShrink: 0,
            cursor: "pointer"
          }}
          onClick={() => {
            setColorDialogOpen(true);
          }}
        />
        <ColorPickerDialog
          open={colorDialogOpen}
          label={label}
          initialColor={initialColor}
          saveChanges={newcolor => {
            const payload = { [property]: newcolor.hex };
            if (linkedProperties) {
              linkedProperties.forEach(property => {
                payload[property] = newcolor.hex;
              });
            }
            updateChanges(payload);
            setColorDialogOpen(false);
          }}
          handleClose={() => {
            setColorDialogOpen(false);
          }}
        />
      </Grid>
    </>
  );
};

export default ColorPickerElement;
